// Keep Image/Logo module link data in sync with new link field format
export const syncImageLinkData = (module, data, schema) => {
  const {
    type,
    body
  } = module;
  if ((type === 'linked_image' || schema.path === '@hubspot/linked_image') && body && data && (body.link !== data.link || body.target !== data.target)) {
    return Object.assign({}, data, {
      img_link: {
        no_follow: false,
        open_in_new_tab: data.target,
        url: {
          type: 'EXTERNAL',
          href: data.link,
          content_id: null
        }
      }
    });
  }
  if ((type === 'logo' || schema.path === '@hubspot/logo') && body && data && (body.link !== data.link || body.open_in_new_tab !== data.open_in_new_tab)) {
    return Object.assign({}, data, {
      img_link: {
        no_follow: false,
        open_in_new_tab: data.open_in_new_tab,
        url: {
          type: 'EXTERNAL',
          href: data.link,
          content_id: null
        }
      }
    });
  }
  return data;
};